import { forwardRef, HTMLAttributes } from "react";
import { ActiveBar } from "./components/ActiveBar/active-bar";
import { GuideLine } from "./components/GuideLine/guide-line";
import * as SC from "./progress-bar-full-width.styles";

export const Root = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, style, children, ...props }, ref) => {
    return (
      <SC.ProgressBarWrapper
        ref={ref}
        className={className}
        style={style}
        {...props}
      >
        {children}
      </SC.ProgressBarWrapper>
    );
  }
);

Root.displayName = "ProgressBarFullWidth";

export const ProgressBarFullWidth = {
  Root,
  ActiveBar,
  GuideLine,
};
